module.exports = __webpack_public_path__ + "img/10_68.83090b2b.png";